<style lang="scss"
       module>
  @import '../brand/_brandColors.scss';
  @import '../brand/structure.variables';

.header {
  width: 100%;
  background-color: $blue;
  padding: 3.5rem $mobile-spacing;
  font-family: 'Open Sans Condensed', sans-serif;
  font-size: 2.8rem;
  line-height: 3.2rem;
  font-weight: 700;
  text-transform: uppercase;
  color: $white;
  text-align: center;
}

.wrapper {
  composes: wrapper from 'sass-loader!../brand/structure.module.scss';
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.logo {
  width: 200px;
  margin-bottom: 2.6rem;
}

.noMargin {
  margin-top: 0;
  margin-bottom: 0;
}

.emphasis {
  color: $orange;
}

@media screen and (min-width: $mobile) {
  .header {
    padding: 6rem;
    font-size: 4.8rem;
    line-height: 5.8rem;
  }
}
</style>
<template>
  <div :class="$style.header">
    <div :class="$style.wrapper">
      <img
        :class="$style.logo"
        src="go2partners.svg"
        alt="">
      <p :class="$style.noMargin">We'll solve your
      <span :class="$style.emphasis">impossible</span> problems</p>
    </div>
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'AppHeader',
};
</script>
